<template>
  <!-- 主容器 -->
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="80px">
      <!-- 课程名称搜索 -->
      <el-form-item label="课程名称" prop="courseName">
        <el-input v-model="queryParams.courseName" placeholder="请输入课程名称" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 专业选择搜索 -->
      <el-form-item label="所属专业" prop="majorId">
        <el-select v-model="queryParams.majorId" placeholder="请选择专业" clearable size="small">
          <el-option v-for="major in majorOptions" :key="major.majorId" :label="major.majorName"
            :value="major.majorId" />
        </el-select>
      </el-form-item>

      <!-- 学期选择搜索 -->
      <el-form-item label="所在学期" prop="semester">
        <el-select v-model="queryParams.semester" placeholder="请选择学期" clearable size="small">
          <el-option v-for="(item, index) in 8" :key="index" :label="`第${index + 1}学期`" :value="`第${index + 1}学期`" />
        </el-select>
      </el-form-item>

      <!-- 搜索按钮 -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
          搜索
        </el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 操作按钮区域 -->
    <el-row :gutter="10" class="mb8" v-if="identity === 'admin'">
      <!-- 新增按钮 -->
      <el-col :span="1.5">
        <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd">
          新增
        </el-button>
      </el-col>

      <el-col :span="1.5">
        <el-button type="success" plain icon="el-icon-edit" size="mini" :disabled="single"
          @click="handleUpdate">修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple"
          @click="handleDelete">删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
    </el-row>

    <!-- 学生视图 - 学期课程列表 -->
    <template v-if="identity === 'student' && !loading">
      <template v-for="semester in 4">
        <el-list v-if="coursesForm.some(item => item.semester === `第${semester}学期`)" :key="semester"
          :class="`xueqi${semester}`" style="background-color: inherit">
          <div class="item-title1">{{ coursesForm[0].majorName }} 第{{ semester }}学期</div>
          <el-list-item v-for="(item, index) in coursesForm.filter(item => item.semester === `第${semester}学期`)"
            :key="index">
            <el-list-item__content>
              <div class="item-content">
                <div class="item-title">{{ item.courseName }} ：<span class="item-desc">{{ item.mingXi }}</span></div>
                
              </div>
            </el-list-item__content>
          </el-list-item>
        </el-list>
      </template>
    </template>
    <!-- 管理员视图 - 数据表格 -->
    <el-table v-loading="loading" :data="coursesForm" style="width: 100%" v-if="identity === 'admin'"
      @selection-change="handleSelectionChange">
      <!-- 选择列 -->
      <el-table-column type="selection" width="55" align="center" />

      <!-- 课程ID列 -->
      <el-table-column label="编号" prop="id" align="center" />

      <!-- 课程名称列 -->
      <el-table-column label="课程名" prop="courseName" align="center" />

       <!-- 专业列 -->
      <el-table-column label="所属专业" prop="majorName" align="center" />

      <!-- 学期列 -->
      <el-table-column label="所在学期" prop="semester" align="center" />

     
      <!-- 课时数列 -->
      <el-table-column label="课时数" prop="classHours" align="center" />

      <!-- 明细列 -->
      <el-table-column label="课程详情" prop="mingXi" align="center" />

      <!-- 操作列 -->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">
            修改
          </el-button>
          <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination background class="pagination-container" v-show="total > 0 && identity === 'admin'"
      :current-page="queryParams.pageNum" :page-sizes="[5, 10, 20, 50]" :page-size="queryParams.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body v-if="identity === 'admin'">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="课程名称" prop="courseName">
          <el-input v-model="form.courseName" placeholder="请输入课程名称" />
        </el-form-item>

        <el-form-item label="所属专业" prop="majorId">
          <el-select v-model="form.majorId" placeholder="请选择专业">
            <el-option v-for="major in majorOptions" :key="major.majorId" :label="major.majorName"
              :value="major.majorId" />
          </el-select>
        </el-form-item>
        <el-form-item label="所在学期" prop="semester">
          <el-select v-model="form.semester" placeholder="请选择学期">
            <el-option v-for="(item, index) in 8" :key="index" :label="`第${index + 1}学期`" :value="`第${index + 1}学期`" />
          </el-select>
        </el-form-item>

        

        <el-form-item label="课时数" prop="classHours">
          <el-input-number v-model="form.classHours" controls-position="right" :min="1" />
        </el-form-item>

        <el-form-item label="课程详情" prop="mingXi">
          <el-input type="textarea" v-model="form.mingXi" placeholder="请输入课程明细（每行一条，支持换行）" rows="4" maxlength="500"
            show-word-limit />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listCourses, getCourses, delCourses, addCourses, updateCourses } from "@/api/OmdCourses/courses";
import { listMajors } from "@/api/OmdMajors/majors";
import { download } from "@/utils/request";


export default {
  name: "CoursesMain",
  data() {
    return {
      // 加载状态
      loading: true,
      // 选中行的ID数组
      ids: [],
      // 是否单选（用于判断修改按钮状态）
      single: true,
      // 是否多选（用于判断删除按钮状态）
      multiple: true,
      // 是否显示搜索区域
      showSearch: true,
      // 总条数
      total: 0,
      // 课程列表数据
      coursesForm: [],
      // 专业选项数据
      majorOptions: [],
      // 对话框标题
      title: "",
      // 是否显示对话框
      open: false,
     

      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        courseName: null,
        semester: null,
        majorId: null,
        classHours: null,
        mingXi: null
      },

      // 表单数据
      form: {
        id: null,
        courseName: null,
        semester: null,
        majorId: null,
        classHours: null,
        mingXi: null
      },

      // 表单验证规则
      rules: {
        courseName: [
          { required: true, message: "课程名称不能为空", trigger: "blur" }
        ],
        semester: [
          { required: true, message: "请选择学期", trigger: "change" }
        ],
        majorId: [
          { required: true, message: "请选择专业", trigger: "change" }
        ],
        classHours: [
          { required: true, message: "请输入课时数", trigger: "blur" },
          { type: 'number', message: '必须为数字值', trigger: 'blur' }
        ],
        mingXi: [
          { required: true, message: "请输入课程明细", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    // 组件创建时获取数据
    this.getList();
    this.getMajorList();
    // 实际应用中应从用户信息获取身份
    // this.identity = this.$store.state.user.identity;
  },
   computed: {
        identity() {
            return this.$store.state.identity;
        },
    },
  methods: {
    /**
     * 获取课程列表
     */
    getList() {
      this.loading = true;
      listCourses(this.queryParams).then(response => {
        this.coursesForm = response.rows;
        this.total = response.total;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    /**
     * 获取专业列表
     */
    getMajorList() {
      listMajors().then(response => {
        this.majorOptions = response.rows;
      }).catch(error => {
        console.error("获取专业列表失败:", error);
      });
    },

    /**
     * 每页条数变化事件
     */
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },

    /**
     * 当前页变化事件
     */
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },

    /**
     * 搜索操作
     */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    /**
     * 重置搜索表单
     */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        courseName: null,
        semester: null,
        majorId: null,
        classHours: null,
        mingXi: null
      };
      this.handleQuery();
    },

    /**
     * 表格选择项变化事件
     */
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },

    /**
     * 新增操作
     */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加课程";
    },

    /**
     * 修改操作
     */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids[0];
      getCourses(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改课程";
      }).catch(error => {
        console.error("获取课程详情失败:", error);
      });
    },

    /**
     * 提交表单
     */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const operation = this.form.id ? updateCourses(this.form) : addCourses(this.form);

          operation.then(response => {
            this.$modal.msgSuccess(this.form.id ? "修改成功" : "新增成功");
            this.open = false;
            this.getList();
            console.log(response)
          }).catch(error => {
            console.error("操作失败:", error);
          });
        }
      });
    },

    /**
     * 删除操作
     */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirm(`是否确认删除编号为"${ids}"的课程？`, '警告', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'confirm-danger-button',
        cancelButtonClass: 'cancel-button'
      }).then(() => {
        return delCourses(ids);
      }).then(() => {
        this.getList();
        this.$message.success('删除成功');
      }).catch(() => { });
    },

    /**
     * 导出操作
     */
    handleExport() {
      download('/OmdCourses/courses/export', {
        ...this.queryParams
      }, `课程表_${new Date().getTime()}.xlsx`);
    },

    /**
     * 取消操作（关闭对话框）
     */
    cancel() {
      this.open = false;
      this.reset();
    },

    /**
     * 重置表单
     */
    reset() {
      this.form = {
        id: null,
        courseName: null,
        semester: null,
        majorId: null,
        classHours: null,
        mingXi: null
      };
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    }
  }
};
</script>

<style scoped>
/* 主容器样式 */
.app-container {
  padding: 20px;
}


/* 表格操作按钮紧凑样式 */
.small-padding .el-button {
  padding: 5px;
  margin-left: 0;
}


/* 表格头部*/
::v-deep .el-table__header-wrapper .el-table__header th {
  background-color: #f4f4f4 !important;
  ;
  /* 表格头部背景颜色 */
  color: #000 !important;
}

/* 分页器样式 */
::v-deep .el-pager li.active {
  background-color: var(--primary-color) !important;
  color: white !important;
  border-color: var(--primary-color) !important;
  font-weight: bold;
  cursor: pointer;
}

/* 分页器样式 */
::v-deep .el-pager li.active:hover {
  background-color: #d6336c !important;
  color: white !important;
  background-color: #d6336c !important;
  font-weight: bold;
  cursor: pointer;
}

/*按钮的样式 主要按钮 的样式*/

::v-deep .el-button--primary {
  color: #fff;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
  background-color: #d6336c !important;
  ;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 表格中的文字 */
/* ::v-deep .el-button--text  {
  color: var(--primary-color);
}   */


::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background-color: var(--primary-color);
  border: none;
  color: #fff;
}

/* 文本框 初始边框
::v-deep .el-input__inner,.el-textarea__inner {
  border:1px solid var(--primary-color);
} */
/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 在全局样式或组件样式中添加 */
::v-deep.confirm-delete-button {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}

::v-deep.confirm-delete-button:hover {
  background-color: #e05c5c !important;
  border-color: #e05c5c !important;
}
/* 学生视图样式调整 - 保留原有风格并增强响应式 */

/* 学期标题（一级标题） */
.item-title1 {
  font-size: 1.5rem; /* 约24px - 一级标题大小 */
  margin-top: 1.25rem; /* 20px */
  padding-left: 0.3125rem; /* 5px */
  color: #000;
  font-weight: bold;
  margin-left: 1.25rem; /* 20px */
}

/* 课程名称（二级标题） */
.item-title {
  font-size: 1.125rem; /* 约18px - 二级标题大小 */
  margin-top: 0.625rem; /* 10px */
  padding-left: 0.3125rem; /* 5px */
  color: #000;
  font-weight: bold;
  margin-left: 1rem; /* 20px */
}

/* 课程明细（正文） */
.item-desc {
  padding: 0.625rem 0 !important; /* 10px */
  font-size: 1rem; /* 16px - 标准正文大小 */
  margin-left: 0.3125rem; /* 5px */
  font-weight: normal;
  color:#333;
}

/* 课程内容容器 - 保持原有布局 */
.item-content {
  display: flex;
  align-items: center;
  gap: 0.2rem; /* 5px */
  width: 100%;
  padding: 0.625rem 0; /* 10px */
  border-bottom: 1px dashed #e0224d; /* 恢复点状线 */
}

/* 学期背景色 - 增强版 */
.xueqi1, .xueqi2, .xueqi3, .xueqi4 {
  border-radius: 0.625rem !important;
  margin-top: 1.875rem !important;
  padding: 0.625rem !important;
  display: flex;
  flex-direction: column;
  min-height: 50px; /* 最小高度 */
  padding: 15px 20px !important; /* 增加内边距 */
  margin-bottom: 20px;
}
.xueqi1 { background-color: #fff1f4 !important; }
.xueqi2 { background-color: #f6e0e2 !important; }
.xueqi3 { background-color: #f4cacc !important; }
.xueqi4 { background-color: #f1b3b9 !important; }
/* 响应式调整 */
@media (max-width: 992px) {
  /* 大平板设备调整 */
  .item-title1 {
    font-size: 1.375rem; /* 约22px */
    margin-left: 1rem; /* 16px */
  }
}

@media (max-width: 768px) {
  /* 平板设备调整 */
  .item-title1 {
    font-size: 1.25rem; /* 约20px */
    margin-left: 0.75rem; /* 12px */
  }
  
  .item-title {
    font-size: 1rem; /* 16px */
    margin-left: 0.75rem; /* 12px */
  }
  
  .item-desc {
    font-size: 0.9375rem; /* 15px */
  }
  
  .item-content {
    flex-wrap: wrap; /* 小屏幕允许换行 */
  }
}

@media (max-width: 576px) {
  /* 手机设备调整 */
  .item-title1 {
    font-size: 1.125rem; /* 约18px */
    margin-left: 0.5rem; /* 8px */
  }
  
  .item-title {
    font-size: 0.9375rem; /* 15px */
    margin-left: 0.5rem; /* 8px */
    min-width: 100%; /* 小屏幕独占一行 */
    margin-bottom: 0.25rem; /* 4px */
  }
  
  .item-desc {
    font-size: 0.875rem; /* 14px */
    margin-left: 0.5rem; /* 8px */
    padding-left: 0.5rem; /* 8px */
  }
  
  /* 学期区块调整 */
  .xueqi1, .xueqi2, .xueqi3, .xueqi4 {
    margin-top: 1.25rem; /* 20px */
    padding: 0.5rem; /* 8px */
  }
}

</style>